import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';

@Component({
    selector: 'atx-formly',
    template: `<form [formGroup]="form"
      (ngSubmit)="fireSubmit.emit()">
    <formly-form [model]="model"
                 [fields]="fields"
                 [form]="form">
        <ng-content></ng-content>
    </formly-form>
</form>
`,
    styles: [``],
})

export class AtxFormlyComponent implements OnInit {
    @Input() public readonly form;
    @Input() public readonly model;
    @Input() public readonly fields;
    @Input() public readonly inline: boolean;

    @Output('onSubmit') public readonly fireSubmit: EventEmitter<any> = new EventEmitter();

    constructor(private readonly fb: FormBuilder) {
        this.form = fb.group({});
    }

    public ngOnInit() {
        if (this.inline) {
            this.setInlineWrapper();
        }
    }

    private setInlineWrapper() {
        for (const element of this.fields) {
            if (element.fieldGroup) {
                element.fieldGroup.map((field) => {
                    field.wrappers = [ 'field-horizontal' ];
                });
            }
        }
    }
}
